import Vue from "vue"
import Vuex from "vuex"
import {filials} from "@/plugins/vuex/filials"
import {doctors} from "@/plugins/vuex/doctors"
import {filialSpecialities} from "@/plugins/vuex/filial-specialities"
import {doctorFilials} from "@/plugins/vuex/doctor-filials"
import {filialDoctors} from "@/plugins/vuex/filial-doctors"
import {specialities} from "@/plugins/vuex/specialities"
import {services} from "@/plugins/vuex/services"
import {schedule} from "@/plugins/vuex/schedule"
import {patient} from "@/plugins/vuex/patient"
import {sms} from "@/plugins/vuex/sms"
import {step} from "@/plugins/vuex/step"

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    filials,
    filialSpecialities,
    doctorFilials,
    filialDoctors,
    doctors,
    specialities,
    services,
    schedule,
    patient,
    sms,
    step
  },
})